<script lang="ts">
    import type {SutorHomePageData} from 'src/features/sutor/pages/homepage/types';
    import SutorHomePageIconCard from 'src/features/sutor/pages/homepage/components/SutorHomePageIconCard.svelte';

    export let homepageData: SutorHomePageData;
</script>

<div class="links-card-content">
    <ul class="cards-group-container">
        <li class="info-card-item">
            <SutorHomePageIconCard href="/#!/projects"
                                   icon="check-circle"
                                   label="Zakázky"
                                   value="{homepageData.fondItemCounts[1]}"
                                   iconBackground="#DE455A"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard href="/#!/record-grid/fond/77/view"
                                   icon="check-circle"
                                   label="Objednávky"
                                   value="{homepageData.fondItemCounts[77]}"
                                   iconBackground="#DE455A"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard href="/#!/record-grid/fond/107/view"
                                   icon="check-circle"
                                   label="Faktury s položkami"
                                   value="{homepageData.fondItemCounts[107]}"
                                   iconBackground="#DE455A"/>
        </li>
    </ul>

    <ul class="cards-group-container">
        <li class="info-card-item">
            <SutorHomePageIconCard icon="edit"
                                   href="/#!/reports"
                                   label="Zadávání výkazů"
                                   iconBackground="#FF751F"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard icon="assept-document"
                                   href="/#!/reports/approving"
                                   label="Schvalování výkazů"
                                   iconBackground="#FF751F"/>
        </li>
    </ul>

    <ul class="cards-group-container">
        <li class="info-card-item">
            <SutorHomePageIconCard icon="users"
                                   href="/#!/employees"
                                   label="Evidovaní pracovníci"
                                   value="{homepageData.employeesCount}"
                                   iconBackground="#3951C8"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard icon="grid-alt"
                                   href="/#!/record-grid/fond/9/view"
                                   label="Evidovaný majetek"
                                   value="{homepageData.fondItemCounts[9]}"
                                   iconBackground="#3951C8"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard icon="building"
                                   href="/#!/departments"
                                   label="Divize"
                                   value="{homepageData.departmentsCount}"
                                   iconBackground="#3951C8"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard icon="building"
                                   href="/#!/record-grid/fond/2/view"
                                   label="Firmy"
                                   value="{homepageData.fondItemCounts[2]}"
                                   iconBackground="#3951C8"/>
        </li>
    </ul>

    <ul class="cards-group-container">
        <li class="info-card-item">
            <SutorHomePageIconCard icon="tools"
                                   href="/#!/record-grid/fond/70/view"
                                   label="Profese"
                                   value="{homepageData.fondItemCounts[70]}"
                                   iconBackground="#9747FF"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard icon="cube"
                                   href="/#!/record-grid/fond/71/view"
                                   label="Skupiny majetku"
                                   value="{homepageData.fondItemCounts[71]}"
                                   iconBackground="#9747FF"/>
        </li>
    </ul>

    <ul class="cards-group-container">
        <li class="info-card-item">
            <SutorHomePageIconCard icon="grid-alt"
                                   href="/#!/record-grid/fond/106/view"
                                   label="Katalog činností"
                                   value="{homepageData.fondItemCounts[106]}"
                                   iconBackground="#51BB80"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard icon="grid-alt"
                                   href="/#!/record-grid/fond/12/view"
                                   label="Ceníky"
                                   value="{homepageData.fondItemCounts[12]}"
                                   iconBackground="#51BB80"/>
        </li>

        <li class="info-card-item">
            <SutorHomePageIconCard icon="grid-alt"
                                   href="/#!/record-grid/fond/13/view"
                                   label="Smlouvy"
                                   value="{homepageData.fondItemCounts[13]}"
                                   iconBackground="#51BB80"/>
        </li>
    </ul>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .links-card-content {
        display: flex;
        flex-direction: column;
        gap: @spacing-l;
        flex-wrap: wrap;

        .cards-group-container {
            display: flex;
            flex-wrap: wrap;
            gap: @spacing-ml;
        }
    }
</style>